



































































































































































































































































































































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
  Inject
} from "@/shared/vuepack";
import { PlanType, FundingOption, Permission } from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import Select from "@/shared/components/ui/Select.vue";
import CompanyInfo from "@/shared/companyInfo";
import { formatCurrency } from "@/shared/currency.js";
import { CensusManager, Employee } from "@/employer/types";
import { Validator } from "vee-validate";
import moment from "moment";
import * as _ from "lodash";
import { Location } from "vue-router";
import UsStateSelector from "@/shared/components/UsStateSelector.vue";
import TabGroupRouted from "@/shared/components/ui/TabGroupRouted.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import EnrollmentStatus from "@/employer/components/shared/EnrollmentStatus.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import EmployeePlanYearContributions from "@/employer/components/profile/EmployeePlanYearContributions.vue";
import { umbMaximumAddressLineLength } from "@/shared/custodianSettings/employee/umb";
import { useNotifierStore } from "@/shared/store/notifier";
import { useEmployeeStore } from "@/employer/store/employee";
import { useUserStore } from "@/shared/store/user";
import { useProfileStore } from "@/employer/store/profile";
import { usePayrollSummaryToDateStore } from "@/employer/store/payrollSummaryToDate";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import payroll from "../../../shared/resource/payroll";

const initialEmployee: Employee = {
  employerId: 0,
  employeeId: 0,
  externalEmployeeId: "",
  firstName: "",
  lastName: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
  country: "",
  dateOfBirth: "",
  ssn: "",
  accountTypeEffectiveDate: "",
  effectiveDate: "",
  accountType: "",
  email: "",
  isEnrolled: false,
  terminationDate: "",
  hsaEligibilityEndDate: "",
  annualElection: null,
  canResendInvite: false,
  hsaIntervals: []
};

@Component({
  computed: {
    payroll () {
      return payroll;
    }
  },
  components: {
    UsStateSelector,
    Button,
    Select,
    EnrollmentStatus,
    ErrorSummary,
    EmployeePlanYearContributions,
    TabGroupRouted,
    Tab
  }
})
export default class EmployeeAddEdit extends Vue {
  @Inject()
  $validator: Validator;

  notifierStore = useNotifierStore();
  employeeStore = useEmployeeStore();
  userStore = useUserStore();
  payrollSummaryToDateStore = usePayrollSummaryToDateStore();
  custodianSettingsStore = useCustodianSettingsStore();
  rolePermissionsStore = useRolePermissionsStore();
  profileStore = useProfileStore();

  isSubmitting = false;
  isSsnDirty = true;
  formModel: Employee = null;
  isLoaded = false;
  inviteSent = false;
  editMode = false;
  showEmployeeChangeMessage = false;
  originalSsn = null;
  planTypeChanged = false;
  originalPlanType = null;
  originalTerminationDate = null;

  formatCurrency = formatCurrency;
  PlanType = PlanType;
  formatIntervalDate (date: string) { return moment(date).format("MMM Do, YYYY"); }

  get addMode () {
    return this.employeeId === 0;
  }

  addressLineValidation = { max: umbMaximumAddressLineLength };

  @Prop()
  employeeId: number;
  @Prop()
  routeToEmployeeList;

  @Watch("employeeStore.pages")
  onEmployeesChanged () {
    this.initializeFromStateValue();
    this.getEmployeePayrollData();
  }

  @Watch("employeeId")
  onRouteValueEmployeeIdChanged () {
    if (
      this.isLoaded &&
      this.formModel &&
      this.formModel.employeeId === this.employeeId
    ) {
      return;
    }
    this.formModel = null;
    this.isLoaded = false;
    this.initializeFromStateValue();
    this.fetchEmployeeDetail();
  }

  get allowEmployeeEdit (): boolean {
    if (!this.rolePermissionsStore.userHasPermission(Permission.EmployeeWrite)) {
      return false;
    }

    return this.userStore.currentEmployer && this.userStore.currentEmployer.censusManager === CensusManager.bend
      && this.userStore.currentEmployer.isTerminated === false;
  }

  get hsaEligibilityDateValidator () {
    if (this.canValidateEffectiveDateIsNotAFutureDate) {
      return "required|validateIsNotFutureDate";
    }
    return "required";
  }

  get planTypeChangeEffectiveDateValidator () {
    if (this.formModel.terminationDate) {
      const terminationDate = moment(this.formModel.terminationDate).format("yyyy-MM-DD");
      return `required|date_format:yyyy-MM-DD|before:${terminationDate}`;
    }
    return "required";
  }

  get canValidateEffectiveDateIsNotAFutureDate () {
    const employee = this.employeeStore.getEmployeeById(this.employeeId);
    return employee && employee.effectiveDate
      && this.editingLocked
      && !employee.hsaEligibilityEndDate && !employee.terminationDate
      && moment(employee.effectiveDate).isSameOrBefore(moment());
  }

  get showPayroll () {
    return this.employeeEnrolled;
  }

  get eligibilityIntervals () {
    return this.employeeStore.historicalEligibilityIntervals(this.employeeId);
  }

  get hasEligibilityIntervals () {
    return this.eligibilityIntervals.length > 0;
  }

  get editingLocked () {
    return this.formModel && this.formModel.enrollmentStatus && this.formModel.enrollmentStatus !== "notStarted";
  }

  get employeeEnrolled () {
    return !this.addMode && this.formModel && this.formModel.enrollmentStatus && this.formModel.enrollmentStatus === "enrolled";
  }

  get editableEmployeeInformationForm (): boolean {
    if (!this.rolePermissionsStore.userHasPermission(Permission.EmployeeWrite)) {
      return false;
    }

    return (this.addMode || this.editMode) && !this.editingLocked && this.isLoaded;
  }

  handleCancelUpdate () {
    this.formModel.accountTypeEffectiveDate = null;
    // we are canceling the latest change, so change the account type to the opposite of what it was
    if (this.formModel.accountType === PlanType.Family) {
      this.formModel.accountType = PlanType.Individual;
    } else {
      this.formModel.accountType = PlanType.Family;
    }

    this.onSubmit();
  }

  cancel () {
    if (this.employeeId === 0) {
      this.$router.push(this.routeToEmployeeList);
    }
    this.formModel = null;
    this.editMode = false;
    this.isLoaded = false;
    this.initializeFromStateValue();
  }

  cloneToCurrentModel (o) {
    const clonedModel = _.cloneDeep(o);
    clonedModel.employerId = this.userStore.employerId;
    this.formModel = clonedModel;
    this.isLoaded = true;
  }

  initializeFromStateValue () {
    this.$validator.pause();

    const employee = this.employeeStore.getEmployeeById(this.employeeId);
    if (this.formModel || this.employeeId === 0) {
      this.cloneToCurrentModel(initialEmployee);
      this.isSsnDirty = true;
    } else if (employee) {
      this.cloneToCurrentModel(employee);
      this.isSsnDirty = false;
      this.originalPlanType = this.formModel.accountType;
      this.originalTerminationDate = this.formModel.terminationDate;
    } else {
      this.isLoaded = false;
    }

    this.resetAndResumeValidator();
  }

  resetAndResumeValidator () {
    this.$nextTick(() => {
      this.$validator.reset();
      this.$validator.resume();
    });
  }

  created () {
    this.$validator.extend("notBeforeEffectiveDate", {
      getMessage: field => `The ${field} cannot be before HSA Eligibility Start Date`,
      validate: value => moment(value).isSameOrAfter(moment(this.formModel.effectiveDate))
    });
  }

  mounted (): void {
    this.initializeFromStateValue();
    this.fetchEmployeeDetail();
    this.getEmployeePayrollData();
    this.custodianSettingsStore.getEmployerCustodian();
    this.userStore.getEmployerUpdateCensusSetting(this.userStore.employerId);
    this.profileStore.loadProfileInformation(this.userStore.employerId);
  }

  getEmployeePayrollData () {
    if (this.employeeEnrolled) {
      this.payrollSummaryToDateStore.getEmployeeYearToDatePayroll({
        employerId: this.userStore.employerId,
        externalEmployeeId: this.formModel.externalEmployeeId,
      })
        .catch(this.handleError);
    }
  }

  fetchEmployeeDetail () {
    if (this.employeeId !== 0) {
      this.employeeStore.getEmployeeDetail({
        employerId: this.userStore.employerId,
        employeeId: this.employeeId
      })
        .catch(this.handleError);
    }
  }

  enrollmentStatusDisplayText (employee): string {
    return this.employeeStore.enrollmentStatusText(employee);
  }

  get displayInitials () {
    if (!this.formModel.firstName || !this.formModel.lastName) {
      // Whatever the default initials should be if you don't have a name
      return "NA";
    }

    return `${this.formModel.firstName[0]}${this.formModel.lastName[0]}`;
  }

  get showEmployeeTerminationDate () {
    return !this.addMode;
  }

  get showEligibilityEndDate () {
    return !this.addMode;
  }

  get showEffectiveDateInput () {
    return (this.planTypeChanged || this.hasPendingChanges) && this.employeeId;
  }

  @Watch("formModel.accountType")
  effectivePlanChangeDateValidation () {
    if (this.originalPlanType !== this.formModel.accountType) {
      this.planTypeChanged = true;
    } else {
      this.planTypeChanged = false;
    }
  }

  get annualContributionValidation () {
    const yearsOld = moment().year() - moment(this.dateOfBirth).year();
    return this.formModel.accountType && this.formModel.accountType === PlanType.Family
      ? `decimal:2|between:0,${CompanyInfo.familyHsaLimit(moment().year(), yearsOld)}`
      : `decimal:2|between:0,${CompanyInfo.individualHsaLimit(moment().year(), yearsOld)}`;
  }

  get employeeEmailValidation () {
    let validationString = "required|email";

    if (this.custodianSettingsStore.validateEmployeeEmailLength) {
      validationString += "|max:40";
    }

    return validationString;
  }

  get terminationDateIsInPast () {
    if (this.originalTerminationDate) {
      const now = moment();
      const terminationDate = moment(this.originalTerminationDate);

      return terminationDate < now;
    }

    return false;
  }

  get terminationDateValidation () {
    let validator = "date_format:yyyy-MM-dd";

    if (this.terminationDateIsInPast) {
      // the date_between validator is exclusive,
      // add 1 day to ensure that the existing value for termination date is valid for submission
      const formattedEffectiveDate = moment(this.formModel.effectiveDate).format("YYYY-MM-dd");
      const formattedLastValidDay = moment().subtract(1, "days").format("YYYY-MM-dd");
      validator += `|date_between:${formattedEffectiveDate},${formattedLastValidDay}`;
    } else {
      validator += "|notBeforeEffectiveDate";
    }

    return validator;
  }

  get ssn (): string {
    const ssn = this.formModel.ssn;
    if (!ssn) {
      return null;
    }
    return ssn;
  }

  set ssn (ssn) {
    this.formModel.ssn = ssn;
  }

  onclickCancelEditSsn () {
    this.ssn = this.originalSsn;
    this.isSsnDirty = false;
  }

  get maskedSsn () {
    return "XXX-XX-" + this.formModel.ssn;
  }

  get hsaEffectiveDate () {
    const { effectiveDate } = this.formModel;
    if (!effectiveDate) {
      return null;
    }

    return moment(effectiveDate).format("MMM DD, YYYY");
  }

  get formattedDateOfBirth () {
    const dateOfBirth = this.formModel.dateOfBirth;
    if (!dateOfBirth) {
      return null;
    }
    return moment(dateOfBirth).format("MMM DD, YYYY");
  }

  get dateOfBirth (): string {
    const dateOfBirth = this.formModel.dateOfBirth;
    if (!dateOfBirth) {
      return null;
    }
    return moment(dateOfBirth).format("MMM DD, YYYY");
  }

  set dateOfBirth (date) {
    this.formModel.dateOfBirth = date;
  }

  get eligibilityStatus () {
    const employee = this.employeeStore.getEmployeeById(this.employeeId);
    if (!employee) {
      return "";
    }
    return this.employeeStore.enrollmentStatusText(employee);
  }

  get showEligibilityStatus () { return this.eligibilityStatus; }

  get futureEffectiveDate () {
    return moment(this.accountTypeEffectiveDate) > moment();
  }

  get hasPendingChanges () {
    return this.futureEffectiveDate && !this.planTypeChanged;
  }

  get accountTypeEffectiveDate () {
    const { accountTypeEffectiveDate } = this.formModel;

    return accountTypeEffectiveDate ? accountTypeEffectiveDate : null;
  }

  set accountTypeEffectiveDate (enteredDate) {
    Vue.nextTick(() => {
      this.formModel.accountTypeEffectiveDate = enteredDate;
    });
  }

  get effectiveDate (): any {
    const effectiveDate = this.formModel.effectiveDate;
    return effectiveDate ? effectiveDate : null;
  }

  set effectiveDate (enteredDate) {
    this.formModel.effectiveDate = enteredDate;
    const mdate = moment(enteredDate);
    if (this.formModel.terminationDate && mdate.isAfter(this.formModel.terminationDate)) {
      this.formModel.hsaEligibilityEndDate = "";
      this.formModel.terminationDate = "";
      return;
    }
    if (this.formModel.hsaEligibilityEndDate && mdate.isAfter(this.formModel.hsaEligibilityEndDate)) {
      this.formModel.hsaEligibilityEndDate = "";
    }
  }

  get terminationDate (): string {
    const terminationDate = this.formModel.terminationDate;
    if (!terminationDate) {
      return null;
    }
    return moment(terminationDate).format("MMM DD, YYYY");
  }

  set terminationDate (date) {
    this.formModel.terminationDate = date;
  }

  get eligibilityEndDate (): string {
    const eligibilityEndDate = this.formModel.hsaEligibilityEndDate;
    if (!eligibilityEndDate) {
      return null;
    }
    return moment(eligibilityEndDate).format("MMM DD, YYYY");
  }

  set eligibilityEndDate (date) {
    this.formModel.hsaEligibilityEndDate = date;
  }

  get saveDisabled (): boolean {
    return this.profileStore.employerInformation.isEnrollmentDisabled;
  }

  onClickEditSsn () {
    this.originalSsn = this.ssn;
    this.ssn = "";
    this.isSsnDirty = true;
  }

  onSubmit (): void {
    const formModel: Employee = { ...this.formModel };
    this.$validator.validateAll().then(result => {
      if (!result || this.profileStore.employerInformation.isEnrollmentDisabled) {
        return;
      }
      if (this.ssn.length === 4) {
        formModel.ssn = "000-00-0000";
      }
      this.isSubmitting = true;
      this.employeeStore.saveEmployeeInformation(formModel)
        .then((obj: { employeeId: number }) => {
          this.isSsnDirty = false;
          this.isSubmitting = false;
          this.notifierStore.setSuccess("Employee information has been saved!");
          if (this.employeeId === 0) {
            const newEmployeeEdit: Location = {
              name: this.$route.name,
              params: {
                employeeId: String(obj.employeeId)
              }
            };
            this.$router.push(newEmployeeEdit);
            return;
          }
          this.editMode = false;
          this.formModel = null;
          this.initializeFromStateValue();
        })
        .then(() => this.planTypeChanged = false)
        .catch(this.handleError);
    });
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
    window.scrollTo({
      behavior: "smooth",
      left: 0,
      top: 0
    });
  }

  sendInvite () {
    if (!this.inviteSent) {
      this.inviteSent = true;
      this.inviteSent = true;
      const request = {
        employerId: this.userStore.employerId,
        employeeId: this.employeeId
      };
      this.employeeStore.resendEmployeeInviteLink(request)
        .then(resp => {
          this.inviteSent = true;
          this.notifierStore.setSuccess(`Invite sent to ${this.formModel.firstName} ${this.formModel.lastName}`);
        })
        .catch(this.handleError);
    }
  }

  get showPayrollInfo (): boolean | any {
    if (!this.rolePermissionsStore.userHasPermission(Permission.PayrollRead)) {
      return false;
    }

    return this.userStore.currentEmployer.fundingOption === FundingOption.BendCalculatePull && this.showPayroll;
  }

  handleError (err: any): void {
    this.isSubmitting = false;
    if (!err) {
      this.showError("Error processing your request. Please try again later");
      return;
    }

    if (err.payload) {
      err = err.payload;
    }

    if (err.response) {
      err = err.response;
    }

    if (err.data) {
      err = err.data;
    }

    if (err.validationFailures) {
      err = err.validationFailures[0];
    }

    let message = "Error processing your request. Please try again later";
    if (err.errorMessage) {
      message = err.errorMessage;
    } else if (err.validationFailure) {
      message = err.validationFailure;
    } else if (err.message) {
      message = err.message;
    }

    this.showError(message || "Error processing your request. Please try again later");
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  get isPlanTypeDisabled (): boolean {
    if (!this.userStore.canEmployerUpdateCensus && this.employeeId) {
      return true;
    }
    return this.hasPendingChanges;
  }
}
